import React from 'react';

const donationHeaderRecipeCards2 = ({ firstName = '' } = {}) => (
  <div>
    <h2
      style={{
        fontSize: '40px',
        textAlign: 'center',
        color: '#4a4a4a',
      }}
    >
      Good News {firstName}! Your "A Ministry of Hospitality" is on its way to
      your mailbox.
    </h2>
    <p>*Please allow 2-4 weeks for delivery.</p>
    <br></br>
    <div>
      <p>
        We praise God for your heart to serve others through Gospel-centered
        kindness and hospitality. It’s our prayer that this guide will encourage
        you to <em>“serve one another humbly in love”</em> (Galatians 5:13,
        NIV).
      </p>
      <p>
        {' '}
        The Billy Graham Evangelistic Association is able to offer the hope of
        Jesus Christ through materials like this because of friends like you.
        The Lord is using the gifts and prayers of other believers to reach
        people across the globe with the Gospel—and there are so many more who
        need to hear the Good News. If the Lord is leading you, you can be a
        part of this ministry by giving a secure donation today.
      </p>
      <a href="https://giving.billygraham.org/" className="button is-primary">
        <strong>Help Now</strong>
      </a>
    </div>
  </div>
);

export default donationHeaderRecipeCards2;